// Only choice-bearing API routes opt into the canonical transport format.
// Keep other requests and the caller's original path unchanged.
export function choiceApiPath(path: string) {
  if (
    !/^\/api\/(?:tokens|events|feed|predictions|rounds|odds|game\/(?:rounds|predictions))(?:[/?#]|$)/.test(
      path,
    )
  )
    return path;
  const url = new URL(path, 'http://localhost');
  url.searchParams.set('choiceFormat', 'run-die');
  return url.pathname + url.search + url.hash;
}
